import { useNavigate } from 'react-router-dom';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import type { PendingApprovalProductType } from '../../../../api/types/approvals';
import { PendingApprovalTable } from '../components/PendingApprovalTable';

const TABS: { value: PendingApprovalProductType; label: string; path: string }[] = [
  { value: 'Flight', label: 'Uçak Bileti', path: '/corporate/approvals/flight' },
  { value: 'Hotel', label: 'Otel', path: '/corporate/approvals/hotel' },
  { value: 'RentCar', label: 'Araç Kiralama', path: '/corporate/approvals/rent-car' },
  { value: 'Transfer', label: 'Transfer', path: '/corporate/approvals/transfer' },
  { value: 'Bus', label: 'Otobüs', path: '/corporate/approvals/bus' },
];

/**
 * Onay Kuyrukları (corporate pending-approval queues) — migration guide Bölüm 5.3 / 6.2. One
 * page shared by four thin routes (`corporate/approvals/{flight,hotel,rent-car,transfer}`),
 * switching product type via tabs — each tab is its own route so the queue is deep-linkable.
 */
export default function PendingApprovalsPage({ productType }: { productType: PendingApprovalProductType }) {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Onay Listeleri
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Sepette PolicySendApproval devreye girdiğinde oluşan onay talepleri — yöneticiler burada
        onaylar veya reddeder. Çok seviyeli onaylarda talep, mevcut seviye toplam seviyeye
        ulaşana kadar "Pending" kalır.
      </Typography>
      <Tabs
        value={productType}
        onChange={(_e, value: PendingApprovalProductType) => {
          const tab = TABS.find((t) => t.value === value);
          if (tab) navigate(tab.path);
        }}
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        {TABS.map((tab) => (
          <Tab key={tab.value} value={tab.value} label={tab.label} />
        ))}
      </Tabs>
      <PendingApprovalTable productType={productType} />
    </Box>
  );
}
